import { cn } from '@/utils/cn';
import React from 'react';
import { TreeNode } from '../../NestHeadings';
import slugify from 'slugify';

interface TableOfContentsItemProps {
    item: TreeNode;
    scrollTitle: string | null;
    setScrollTitle: React.Dispatch<React.SetStateAction<string | null>>;
}

const TableOfContentsItem: React.FC<TableOfContentsItemProps> = ({
    item,
    scrollTitle,
    setScrollTitle,
}) => {

    const handleClick = (text: string) => {
        const id = slugify(text, { lower: true })
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
            setScrollTitle(text);
        }
    };
    return (
        <div
            onClick={() => handleClick(item?.text)}
            className={cn(
                "hover:text-brand-Orange cursor-pointer",
                scrollTitle === item?.text ? 'text-brand-Orange' : ""
            )}
        >
            {item?.text}
        </div>
    );
};

export default TableOfContentsItem;
